export default __webpack_public_path__ + "static/media/Texting 6.a32ec01f.webp";